import React, {useState} from "react";
import "../../context_dark.css";
import { Stack } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { analysisActions } from "../../../store/store";
import ColorPicker from "../../context_components/color_picker";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Popover from '@mui/material/Popover';

export const AnalysisOptions = () => {
  const dispatch = useDispatch();
  const {
    annotationOptions
  } = useSelector(state => state.analysisStore);
  const {
    color,
    col_100
  } = useSelector(state => state.themeStore);
  const { variantProjects } = useSelector(state => state.projectInfoStore);
  const common = annotationOptions.common;
  const falsePositive = annotationOptions.falsePositive;
  const falseNegative = annotationOptions.falseNegative;
  const [openAnnotationOptions, setOpenAnnotationOptions] = useState(false);
  const [annotationAnchor, setAnnotationAnchor] = useState(null);

  const handleChangeOption = (type) => {
    dispatch(analysisActions.changeAnnotationOptions({
      type: type,
      property: "selected",
      value: !annotationOptions[type]["selected"]
    }))
  }

  const changeColor = (e) => {
    dispatch(analysisActions.changeAnnotationOptions({
      type: e.type,
      property: "color",
      value: e.color
    }))
  }

  const handleOpenProjectSelector = (e)  => {
    setAnnotationAnchor(e.currentTarget);
    setOpenAnnotationOptions(true);
  }

  const handleCloseProjectSelector = () => {
    setAnnotationAnchor(null);
    setOpenAnnotationOptions(false);
  }

  return (
    <Stack spacing={1.5} className="annotation-options-container">
      <Stack direction="row" className="annotation-header-dark">
        <span>
          Annotations
        </span>
        <Stack
          direction="row"
          spacing={0.5}
          className="list-header-selector"
          onClick={handleOpenProjectSelector}
        >
          <span>1</span>
          <KeyboardArrowDownIcon />
        </Stack>

        {/* popover for project selector for annotations */}
        <Popover
          open={openAnnotationOptions}
          anchorEl={annotationAnchor}
          onClose={handleCloseProjectSelector}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <Stack className="project-selector" spacing={0.2}>
            {(variantProjects.length > 0) && 
              variantProjects.map(r => (
                <span>{r}</span>
              ))}
          </Stack>
        </Popover>
      </Stack>
      <div
        className={`annotation-option-dark`}
        style={{
          color: common.selected ? color : "rgba(255, 255, 255, 0.5)",
          transition: "color 0.35s ease-in-out",
        }}
      >
        <span onClick={() => handleChangeOption("common")}>Common</span>
        <Stack className="annotation-sub-group" direction="row" spacing={1.5}>
          <span>{common.value}</span>
          <ColorPicker
            type="common"
            color={common.color}
            changeColor={changeColor}
          />
        </Stack>
      </div>
      <div
        className={`annotation-option-dark`}
        style={{
          color: falsePositive.selected ? color : "rgba(255, 255, 255, 0.5)",
          transition: "color 0.35s ease-in-out",
        }}
      >
        <span onClick={() => handleChangeOption("falsePositive")}>False Positive</span>
        <Stack className="annotation-sub-group" direction="row" spacing={1.5}>
          <span>{falsePositive.value}</span>
          <ColorPicker
            type="falsePositive"
            color={falsePositive.color}
            changeColor={changeColor}
          />
        </Stack>
      </div>
      <div
        className={`annotation-option-dark`}
        style={{
          color: falseNegative.selected ? color : "rgba(255, 255, 255, 0.5)",
          transition: "color 0.35s ease-in-out",
        }}
      >
        <span onClick={() => handleChangeOption("falseNegative")}>False Negative</span>
        <Stack className="annotation-sub-group" direction="row" spacing={1.5}>
          <span>{falseNegative.value}</span>
          <ColorPicker
            type="falseNegative"
            color={falseNegative.color}
            changeColor={changeColor}
          />
        </Stack>
      </div>
    </Stack>
  )
}